const scheduleEs = [
  {
    day: 17,
    schedule: [
      {
        title: 'El Congreso comienza',
        start: '09:00:00',
      },
      {
        title: 'El Business Trade Show comienza',
        start: '12:00:00',
      },
      {
        title: 'Pausa para el almuerzo',
        start: '13:00:00',
        end: '14:40:00',
      },
      {
        title: 'El Congreso termina',
        start: '18:30:00',
      },
      {
        title: 'Ceremonia Solemne de Apertura',
        start: '19:00:00',
      },
      {
        title: 'El Business Trade Show termina',
        start: '21:30:00',
      },
    ],
  },
  {
    day: 18,
    schedule: [
      {
        title: 'El Congreso comienza',
        start: '09:00:00',
      },
      {
        title: 'El Business Trade Show comienza',
        start: '12:00:00',
      },
      {
        title: 'Pausa para el almuerzo',
        start: '13:00:00',
        end: '14:40:00',
      },
      {
        title: 'El Congreso termina',
        start: '18:30:00',
      },
      {
        title: 'El Business Trade Show termina',
        start: '20:00:00',
      },
    ],
  },
  {
    day: 19,
    schedule: [
      {
        title: 'El Congreso comienza',
        start: '09:00:00',
      },
      {
        title: 'El Business Trade Show comienza',
        start: '12:00:00',
      },
      {
        title: 'Pausa para el almuerzo',
        start: '13:00:00',
        end: '14:40:00',
      },
      {
        title: 'El Congreso termina',
        start: '18:30:00',
      },
      {
        title: 'El Business Trade Show termina',
        start: '20:00:00',
      },
    ],
  },
  {
    day: 20,
    schedule: [
      {
        title: 'El Congreso comienza',
        start: '09:00:00',
      },
      {
        title: 'El Business Trade Show comienza',
        start: '12:00:00',
      },
      {
        title: 'El Congreso termina',
        start: '13:00:00',
      },
      {
        title: 'El Business Trade Show termina',
        start: '17:00:00',
      },
    ],
  },
];

export default scheduleEs;



/** WEBPACK FOOTER **
 ** ./src/fixtures/scheduleEs.js
 **/